import { SWRConfiguration } from 'swr';

import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

export type NotificationOptOutResponse = Record<string, boolean>;

export const getNotificationOptOutSettings =
  (): Promise<NotificationOptOutResponse> =>
    fetchFromOldApi('/json/user/notification/optout').then((r) => r.json());

export const putNotificationOptOuts = (
  preferences: NotificationOptOutResponse,
): Promise<NotificationOptOutResponse> =>
  fetchFromOldApi('/json/user/notification/optout', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(preferences),
  }).then((r) => r.json());

export const useGetNotificationsOptOutSettings = (
  userId: number,
  swrConfig?: SWRConfiguration,
  disabled?: boolean,
): UseSWROutput<NotificationOptOutResponse> => {
  return useSWR(
    !disabled ? ['getNotificationOptOutSettings', userId] : null,
    ([_key]) => getNotificationOptOutSettings(),
    swrConfig,
  );
};
